module.exports = __webpack_public_path__ + "static/media/Museo-300.36e77759.ttf";